module.exports = __webpack_public_path__ + "static/Liliam-Franca-b4fe427d8401a0b45b11218947291b7f.jpg";